import { useEffect, useState } from 'react';
import { planes } from './planes.service';

interface PlanFeature {
  cantidad: number;
  caracteristica: string;
  precioUnitario: number;
}

interface Plan {
  id: number;
  documentId: string;
  nombre: string;
  descripcion: string;
  precioMensual: number;
  caracteristicas: PlanFeature[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export const usePlanes = () => {
  const [data, setData] = useState<Plan[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlanes = async () => {
      try {
        setLoading(true);
        const planesData = await planes();
        setData(planesData);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error fetching plans');
      } finally {
        setLoading(false);
      }
    };

    fetchPlanes();
  }, []);

  return { data, loading, error };
};